import { action, makeObservable, observable } from "mobx";
import { BaseStoreSession } from "../abstracts/store/base-session.abstract";

import type { BackendSessionState } from "../auth/backends";
import { SessionBackend } from "../decoders/ihr-user";

/** Add new members to Base */
export class StoreSession<T = BackendSessionState> extends BaseStoreSession<T> {
  @observable
  currentSession: SessionBackend<T> | null = null;

  constructor(currentSession: SessionBackend<T> | null) {
    super();
    makeObservable(this);
    this.currentSession = currentSession;
  }

  @action
  storeSession = (session: any) => {
    this.currentSession = session;
  };
}
